import { ProductVariant } from '../product';

export interface PriceListDetailsRequest {
  workspaceId: string;
  params: {
    priceListId: string;
    pageNo?: number;
    pageSize?: number;
    sellerWorkspaceId: string;
    customerId: string;
  };
}

export interface PriceListDetailsResponse {
  priceList: PriceList;
  Products: ProductVariant[];
}

export interface PriceList {
  id: string;
  createdDate: string;
  updatedDate: string;
  name: string;
  code: string;
  type: string;
  criteria: string;
  isActive: boolean;
  isArchived: boolean;
  startDate: string;
  endDate: string;
  channelId: number;
  priceConditions: any[];
  priceListItems: {
    id: string;
    createdDate: string;
    updatedDate: string;
    ptr: number;
    pts: number;
    priceListId: string;
    productVariantId: number;
    name: string;
    sku: string;
    minOrderQty: number;
  }[];
}

export interface CreatePriceListRequest {
  name: string;
  code: string;
  criteria?: string;
  sellerWorkspaceId?: string;
  priceListItems?: UpdatedValue[];
  priceConditions?: PriceConditions[];
  doMerge?: boolean;
  type?: string;
  startDate?: string;
  endDate?: string;
}

export interface UpdatedValue {
  productVariantId: number;
  pts: number;
  ptr: number;
}

export interface PriceConditions {
  criteria?: CriteriaEnum;
  id?: string;
  tobedeleted?: boolean;
}

export type PriceListResponse = PriceListItem;
export interface PriceListItem {
  pricing: Pricing[];
  startRecord: number;
  endRecord: number;
  totalRecords: number;
}

export enum CriteriaEnum {
  CFA_CUSTOMER = 'cfa-customer-price',
  CFA = 'cfa-price',
  CUSTOMER = 'customer-price',
  PINCODE = 'pinCode-price',
  PINCODE_CFA = 'pinCode-cfa-price',
  PINCODE_CUSTOMER = 'pinCode-customer-price',
  PINCODE_CFA_CUSTOMER = 'pinCode-cfa-customer-price',
  SEGMENT = 'customer-segment',
}

interface Cfa1 {
  id: string;
  cfaId: string;
  cfaName: string;
  cfaCount?: number;
}

interface Customer {
  id: string;
  customerId: string;
  customerName: string;
  customerCount: number;
}

export interface Pricing {
  code: string;
  name: string;
  createdOn: string;
  type: string;
  criteria: CriteriaEnum;
  status: string;
  priceListId: string;
  noOfProducts: number;
  filterBy: string[];
  segments: { channelId: string; channelName: string }[];
  isActive: boolean;
  isModfied?: boolean;
  cfas: Cfa1[];
  customers: Customer[];
  startDate: string;
  endDate: string;
  totalCount: number;
}

export interface PriceListRequest {
  sellerWorkspaceId: string;
  workspaceId?: string;
  searchKey?: string;
  pageNo?: number;
  pageSize?: number;
  cfaIds?: string[];
  customerIds?: string[];
  criteria?: string[];
  status?: string;
  segments?: any;
}
